// Warning: this file is full of hacks and deprecated in favor of the Alpine
// state. But the signing state is still managed here and events are fired to
// talk to Alpine.
//
// Eventually, this file should be removed and everything should be managed
// in Alpine.

import * as Dialog from "./dialog";
import * as RecipientPicker from "./recipient_picker.js";
import { startSignOne, tweakEmail, onGetSignatureInformations, isPendingSignature } from "./signing";
import { getUITranslation } from "../utils/get_ui_translation";
import * as API from "./api";
import * as Popup from "./components/popup";

//==================================================================================================
// INIT
//==================================================================================================

$(document).on("click", ".docsign-link", onSignDocument);
$(document).on("click", ".docsign-cancel-link", onCancelSignature);
$(document).on("click", ".docsign-infos-link", onGetSignatureInformations);

// Depends on Alpine to be init as it generates the data-attributes on the sign button
document.addEventListener("alpine:initialized", () => {
  $(".js-alpine-esign-wrapper").each(function () {
    let $generateDocButton = $(this);
    const $gf = $generateDocButton.find(".js-alpine-esign-gf");
    const generatedFile = $gf.data("generated-file");
    const signingStatus = $gf.data("signing-file");
    if (generatedFile) {
      setGeneratedFileButtonsForSigning(generatedFile, signingStatus);
    }
  });
});

const SIGN_POLL_DELAY_MS = 60 * 1000;

function monitorFileSigning(generatedFile) {
  fetchPoll(p`/ajax/signing/${generatedFile.id}`, (json) => json.success === undefined, SIGN_POLL_DELAY_MS)
    .then((json) => {
      if (json.success == true) {
        setAlpineSignedState(generatedFile, "signed");
        setSignedInputChecked(generatedFile);
      } else {
        setAlpineSignedState(generatedFile, "failed");
      }
    })
    .catch(() => setAlpineSignedState(generatedFile, "failed"));
}

function setSignedInputChecked(generatedFile) {
  let documentSignedInput = document.getElementById("customer_conv_signed_" + generatedFile.struct_id);
  if (documentSignedInput) {
    documentSignedInput.set_attribute("checked", true);
  }
}

function setAlpineSignedState(generatedFile, state) {
  const event = new CustomEvent("digiforma:signing_state_change", {
    detail: { generated_file_id: generatedFile.id, state: state },
  });
  window.dispatchEvent(event);
}

function cleanAlpineSigningStatus(generatedFile) {
  setAlpineSignedState(generatedFile, "");
}

//==================================================================================================
// SIGN A DOCUMENT
//==================================================================================================

async function onSignDocument(e) {
  e.preventDefault();

  const FAILURE_NO_RECIPIENT = "no_recipient";
  const $generateDocButton = $(this).closest(".js-alpine-esign-wrapper");
  const $generatedFile = $generateDocButton.find(".js-alpine-esign-gf");
  const generatedFileInfo = JSON.parse($generatedFile.attr("data-generated-file"));

  try {
    // Retrieve local and remote allowed signers for the document
    const r = await API.fetch(`/ajax/signing/allowed_signer/${generatedFileInfo.id}`);
    const json = await r.json();

    if (json.success == false) {
      throw json.error;
    }

    // Ask user to select local signers
    let localRecipients = [];
    if (json.signers.require_local == true && json.signers.local && json.signers.local.length > 0) {
      json.signers.local[0].checked = true;
      localRecipients = await RecipientPicker.pick({
        recipients: json.signers.local,
        isSigning: true,
        entity: { type: "local" },
      });
    }

    // Ask user to select remote signers
    let remoteRecipients = [];
    if (json.signers.require_remote == true && json.signers.remote && json.signers.remote.length > 0) {
      json.signers.remote[0].checked = true;
      remoteRecipients = await RecipientPicker.pick({
        recipients: json.signers.remote,
        isSigning: true,
        entity: json.entity,
      });
    }

    if (localRecipients.length === 0 && remoteRecipients === 0) {
      throw FAILURE_NO_RECIPIENT;
    }

    // Third step, allow the user to tweak the signature invitation
    const email_template = await tweakEmail(generatedFileInfo.type);
    if (email_template === null) {
      throw null;
    }

    // Start signing the document
    setAlpineSignedState(generatedFileInfo, "created");

    let operationPromise = null;

    operationPromise = startSignOne(generatedFileInfo.id, {
      signers: {
        local: localRecipients,
        remote: remoteRecipients,
      },
      email_subject: email_template.subject,
      email_body: email_template.body,
    });

    // If signing process successfully initiated, start monitoring
    //
    const signRes = await operationPromise;
    if (signRes.success === true) {
      const invitation_label =
        localRecipients.length + remoteRecipients.length > 1
          ? getUITranslation("les différents signataires recevront sous peu une invitation à signer le document.")
          : getUITranslation("le signataire recevra une invitation à signer le document.");
      Dialog.alertInfo(
        getUITranslation("Signature électronique"),
        `${getUITranslation("Le processus de signature électronique est lancé")}, ${invitation_label}`
      );
      monitorFileSigning(generatedFileInfo);
    } else {
      const errorMessage =
        signRes.error === "invalid_signer_email"
          ? getUITranslation(
              "L'adresse email d'un des signataires est invalide, veuillez la corriger sur sa fiche avant de relancer la signature."
            )
          : getUITranslation(
              "Le processus de signature électronique n'a pas pu être lancé, veuillez essayer à nouveau plus tard ou contacter le support."
            );

      Dialog.alertError(getUITranslation("Signature électronique"), errorMessage);
      setAlpineSignedState(generatedFileInfo, "failed");
    }
  } catch (e) {
    setAlpineSignedState(generatedFileInfo, "failed");

    const popup = document.getElementById("js-sign-error-popup");
    if (!popup) return;

    const bodyEl = popup.querySelector("div.popup__body");

    let message = "";

    switch (e) {
      case FAILURE_NO_RECIPIENT:
        message = getUITranslation("Aucun destinataire O.F/Client n'a pu être identifié, il est impossible de continuer.");
        break;
      case "missing_remote_signers":
        message = getUITranslation("Aucun destinataire pour le client n'a pu être identifié, il est impossible de continuer.");
        break;
      case null: //"Cancel button" was hit -- Not a real error but the promise is broken so it's trapped here
        break;
      default:
        console.error(e);
        message = getUITranslation("Une erreur s'est produite, il est impossible de continuer.");
        break;
    }

    if (bodyEl && message) bodyEl.textContent = message;
    if (message) Popup.open(popup);

    cleanAlpineSigningStatus(generatedFileInfo);
  }
}

//==================================================================================================
// CANCEL A SIGNATURE WORKFLOW
//==================================================================================================
async function onCancelSignature(e) {
  e.preventDefault();

  const $generateDocButton = $(this).closest(".js-alpine-esign-wrapper");
  const $generatedFile = $generateDocButton.find(".js-alpine-esign-gf");
  const generatedFileInfo = JSON.parse($generatedFile.attr("data-generated-file"));

  const val = await Dialog.okCancel(getUITranslation("Êtes-vous sûr de vouloir abandonner la signature de ce document ?"), "");
  if (!val) return;

  try {
    const r = await API.fetch(`/ajax/signing/cancel_signature/${generatedFileInfo.id}`, { method: "DELETE" });
    const json = await r.json();
    if (json["success"] == true) {
      cleanAlpineSigningStatus(generatedFileInfo);
      Dialog.alertInfo("", getUITranslation("Le parcours de signature a été abandonné."));
    } else {
      console.error(json);
      Dialog.alertError(
        getUITranslation("Une erreur est survenue."),
        getUITranslation("Une erreur est survenue, veuillez réactualiser la page et faire un nouvel essai.")
      );
    }
  } catch (e) {
    console.error(e);
    Dialog.alertError(
      getUITranslation("Une erreur est survenue."),
      getUITranslation("Une erreur est survenue, veuillez réactualiser la page et faire un nouvel essai.")
    );
  }
}

//==================================================================================================
// TO BE CLEANED
//==================================================================================================

// Buttons for the Doc generation and Doc signing modals

/**
 * @typedef {{id: number, filepath: string, inserted_at: string, updated_at: string, url: string, template: string, signed: boolean, email_sent_at: string, skills_sent_at: string, ext: string}} GeneratedFile
 */

//==================================================================================================
// POLLING ENGINE
//==================================================================================================

/** @const {number} POLL_WAIT_MS max duration of a polling request in ms */
const POLL_WAIT_MS = 5000;

/**
 * @typedef {{method: "GET"|"POST", url: string, dataType?: "json", data?: object}} AjaxRequest
 */

const waitALittleBit = (combienMs) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("done");
    }, combienMs);
  });
};

const fetchPoll = async function (url, continueFn, pollDelayMs = POLL_WAIT_MS) {
  const controller = new AbortController();

  while (true) {
    const timeoutId = setTimeout(() => controller.abort(), POLL_WAIT_MS);
    const response = await API.fetch(url, { signal: controller.signal });
    const json = await response.json();
    clearTimeout(timeoutId);

    if (!continueFn(json)) {
      return json;
    }

    await waitALittleBit(pollDelayMs);
  }
};

//==================================================================================================
// UTILS
//==================================================================================================

function setGeneratedFileButtonsForSigning(generatedFile, signingStatus) {
  if (generatedFile && isPendingSignature(signingStatus)) {
    monitorFileSigning(generatedFile);
  }
}
